import { defineComponent as _defineComponent } from 'vue'
import NjBtn from "@/components/vuetify-wrappers/NjButton.vue";
import { useRoute } from "vue-router/composables";
import { ApiService, LogService, SnackbarService } from "@/services";
import { computed, ref } from "vue";
import { useAppStore } from "@/pinia/app";
import { useSessionStore } from "@/pinia/session";
import { storeToRefs } from "pinia";
import { VignetteEndpoints } from "@/types";
import { ParsedResponse } from "@/types/utils/CaseTypes";
import { CsvExportResponse } from "@/types/api/CsvExport";


export default /*#__PURE__*/_defineComponent({
  __name: 'ExportButton',
  props: {
    knowWhoId: null
  },
  setup(__props: any) {

const props = __props as { knowWhoId?: string };



const route = useRoute();

const exportId = computed(() => props.knowWhoId ?? route.params.id);

const isSearchPage = computed(() => route.fullPath.includes("search"));

const appStore = useAppStore();
const { constants } = storeToRefs(appStore);
const sessionStore = useSessionStore();
const isWebUser = computed(() => sessionStore.isWebUser);
const exportLimit = computed(() => constants.value?.almanacMaxExports ?? 1500);
const usedExports = computed(() =>
  Math.min(sessionStore.almanacExportCount, 1500)
);
const exportName = computed(() => {
  const routeName = route.name?.toLowerCase() ?? "";
  if (isSearchPage.value) {
    return "search";
  }
  if (routeName.includes("profile")) {
    return "staff";
  }
  return routeName.replace("details", "") ?? "almanac_plus";
});

const remainingExports = computed(() => exportLimit.value - usedExports.value);
const loading = ref(false);

const handleExportResult = (result: ParsedResponse<CsvExportResponse>) => {
  if (result.errorMessage) {
    SnackbarService.displaySnackbar(result.errorMessage, "error", 5000);
  } else {
    // update store with new count
    sessionStore.$patch({
      user: {
        almanacExportCount: result.almanacExportCount,
      },
    });
    // decode the csv
    const encoded = result.csvEncoded;
    const decoded = atob(encoded);
    const blob = new Blob([decoded], { type: "text/csv" });
    const downloadUrl = URL.createObjectURL(blob);
    // create an invisible link to click on programmatically for the download
    const link = document.createElement("a");
    link.href = downloadUrl;
    link.download = `${exportName.value}_export.csv`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    // clean up mem
    URL.revokeObjectURL(downloadUrl);
  }
};

const handleClickEvent = async () => {
  const exportRoute = route.meta?.exportRoute;
  if (remainingExports.value <= 0) {
    SnackbarService.displaySnackbar(
      "You have reached your export limit. Please contact your Dedicated Advisor.",
      "error",
      5000
    );
    return;
  }
  if (exportRoute) {
    loading.value = true;
    let result;
    if (isSearchPage.value) {
      result = await ApiService.getSearchExport(exportRoute);
    } else {
      const id = exportId.value;
      const finalUrl = (exportRoute + id) as VignetteEndpoints;
      result = await ApiService.getNonSearchExport(finalUrl);
    }
    loading.value = false;
    handleExportResult(result);
  } else {
    LogService.error(
      `Export button was clicked on a route w/o proper support. ${route.name}`
    );
  }
};

const formatted = (n: number) => {
  return n.toLocaleString("en-US");
};
// make this use Snackbar Service

return { __sfc: true,props, route, exportId, isSearchPage, appStore, constants, sessionStore, isWebUser, exportLimit, usedExports, exportName, remainingExports, loading, handleExportResult, handleClickEvent, formatted, NjBtn }
}

})